import React from 'react';
import { LyceeDef } from '../../../../../types/lycee/lycee.def';

interface RecapLyceeTypes {
  lycee: LyceeDef;
}

export const RecapLycee = ({ lycee }: RecapLyceeTypes) => {
  return (
    <p>
      Vous êtes actuellement professeur(e) au lycée {lycee.name} situé{' '}
      {lycee.adresse + ', à ' + lycee.ville + ' (' + lycee.codepostal + ')'}
    </p>
  );
};
